import { Link } from 'react-router-dom';
import styled from 'styled-components';

import { DefaultLayout } from 'core/layouts';
import { body1, heading3, link } from 'ui/theme/typography';
import { colors } from 'ui/theme';
import { pxToRem } from 'utils/convert';

import { displayContent } from '../content';

export const TEMPLATE_EDITOR_ERROR_LINK_BACK_TEST_ID = 'template-editor-error-link-back';

export const ErrorContainer = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
`;

export const PageContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 75vh;
`;

export const StyledTitle = styled.div`
  ${heading3};
  text-align: center;
`;

export const StyledMessage = styled.div`
  ${body1};
  color: ${colors.textSecondary};
  margin-top: ${pxToRem(9)};
  text-align: center;
`;

export const StyledLink = styled(Link)`
  ${link};
  margin-top: ${pxToRem(17)};
  text-align: center;
`;

export const EditorError = ({
  image,
  linkBack = (
    <StyledLink to="/templates" data-test={TEMPLATE_EDITOR_ERROR_LINK_BACK_TEST_ID}>
      {displayContent.linkBackToTemplates}
    </StyledLink>
  ),
  message,
  title,
}: {
  image?: React.ReactNode;
  linkBack?: React.ReactNode;
  message: string;
  title: string;
}) => (
  <DefaultLayout>
    <PageContainer>
      <ErrorContainer data-test="template-edit-fetch-error">
        {!!image && image}
        <StyledTitle>{title}</StyledTitle>
        <StyledMessage>{message}</StyledMessage>
        {linkBack}
      </ErrorContainer>
    </PageContainer>
  </DefaultLayout>
);
